// (c) Copyright 2016 Caroline Schnapp. All Rights Reserved. Contact: mllegeorgesand@gmail.com
// See https://docs.shopify.com/themes/customization/navigation/link-product-options-in-menus

Shopify.arrayIncludes = function(e, t) {
  for (var n = 0; n < e.length; n++)
      if (e[n] == t) return !0;
  return !1
}, Shopify.uniq = function(e) {
    for (var t = [], n = 0; n < e.length; n++) Shopify.arrayIncludes(t, e[n]) || t.push(e[n]);
    return t
}

Shopify.updateOptionsInSelector = function(selectorIndex, $product) {

  var productOptionsMap = $product.data('om');

  switch (selectorIndex) {
    case 0:
      var key = 'root';
      var selector = $product.find('.product-variant:eq(0) .product-variants');
      break;
    case 1:
      var key = $product.find('.product-variant:eq(0) .product-variants').val();
      var selector = $product.find('.product-variant:eq(1) .product-variants');
      break;
    case 2:
      var key = $product.find('.product-variant:eq(0) .product-variants').val();  
      key += ' / ' + $product.find('.product-variant:eq(1) .product-variants').val();
      var selector = $product.find('.product-variant:eq(2) .product-variants');
  }
  
  var initialValue = selector.val();
  selector.empty();    
  var availableOptions = productOptionsMap[key];

  selector.find('option').each(function(){
  	$(this).removeAttr('disabled', 'disabled');
  	if ( ! $.inArray($(this).val(), availableOptions) ) {
  		$(this).attr('disabled', 'disabled')
  	}
  })

  if ( availableOptions ) {
    for (var i=0; i<availableOptions.length; i++) {
      var option = availableOptions[i];
      var newOption = jQuery('<option></option>').val(option).html(option);
      selector.append(newOption);
    }
  }

 	selector.parent().find('ul li').each(function(){
 		$(this).removeClass('disabled');
 		if ( $.inArray($(this).text().trim(), availableOptions) === -1 ) {
 			$(this).addClass('disabled');
 		}
  });

  $product.find('.swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {
    if (jQuery.inArray($(this).attr('data-value'), availableOptions) !== -1) {
      $(this).removeClass('soldout').show().find(':radio').removeAttr('disabled','disabled').removeAttr('checked');
    }
    else {
      $(this).addClass('soldout').hide().find(':radio').removeAttr('checked').attr('disabled','disabled');
    }
  });
  if (jQuery.inArray(initialValue, availableOptions) !== -1) {
    selector.val(initialValue);
  }
  selector.trigger('change');  
  
};

Shopify.linkOptionSelectors = function(product, $product) {
  var productOptionsMap = $product.data('om');
  // Building our mapping object.
  for (var i=0; i<product.variants.length; i++) {
    var variant = product.variants[i];
    if (variant.available) {
      // Gathering values for the 1st drop-down.
      productOptionsMap['root'] = productOptionsMap['root'] || [];
      productOptionsMap['root'].push(variant.option1);
      productOptionsMap['root'] = Shopify.uniq(productOptionsMap['root']);
      // Gathering values for the 2nd drop-down.
      if (product.options.length > 1) {
        var key = variant.option1;
        productOptionsMap[key] = productOptionsMap[key] || [];
        productOptionsMap[key].push(variant.option2);
        productOptionsMap[key] = Shopify.uniq(productOptionsMap[key]);
      }
      // Gathering values for the 3rd drop-down.
      if (product.options.length === 3) {
        var key = variant.option1 + ' / ' + variant.option2;
        productOptionsMap[key] = productOptionsMap[key] || [];
        productOptionsMap[key].push(variant.option3);
        productOptionsMap[key] = Shopify.uniq(productOptionsMap[key]);
      }
    }
  }
  // Update options right away.
  Shopify.updateOptionsInSelector(0, $product);
  if (product.options.length > 1) Shopify.updateOptionsInSelector(1, $product);
  if (product.options.length === 3) Shopify.updateOptionsInSelector(2, $product);
  // When there is an update in the first dropdown.
  $product.find(".product-variant:eq(0) .product-variants").change(function() {
    Shopify.updateOptionsInSelector(1, $product);
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2, $product);
    return true;
  });
  // When there is an update in the second dropdown.
  $product.find(".product-variant:eq(1) .product-variants").change(function() {
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2, $product);
    return true;
  });  
};